module.exports = __webpack_public_path__ + "img/error.e10429a1.svg";